import styled from 'styled-components';

import { Main } from './content.styles';
import { Wrapper as HeaderWrapper } from './header.styles';

export const Wrapper = styled.div`
  align-self: stretch;
  background: var(--info-light);
  padding: 15px;
  font-size: 16px;
  text-align: center;

  p {
    margin: 0;
  }

  a {
    color: inherit;
    font-weight: 500;
  }

  @media screen and (min-width: 769px) {
    ${HeaderWrapper} + & {
      border-top-left-radius: var(--border-radius);

      @supports (corner-shape: squircle) {
        border-top-left-radius: calc(var(--border-radius) * 2);
        corner-shape: squircle;
      }
    }

    + ${Main} {
      border-top-left-radius: 0;
    }
  }
`;
